import React, {useEffect, useRef, useState} from "react";
import {ReportApiCalls} from "../../apis/ReportApiCalls";
import classes from "./Report.module.css"
import {YuJaTextBox} from "../../components/standardization/YuJaTextBox";
import { ReactComponent as SearchIcon } from "../../images/search_bar_icon.svg";
import {BUTTON} from "../../utils/constants";
import {MonthPicker} from "./MonthPicker";
import {getYearMonthStr} from "./ReportHelper";
import { ReactComponent as ARROW_RIGHT } from "../../images/arrow_right.svg";
import { ReactComponent as NO_RESULT } from "../../images/no_result.svg";
import {ReactComponent as BACK} from "../../images/arrow-left-purple.svg"
import {ReactComponent as SHARE} from "../../images/share-thin.svg"
import {ReactComponent as DOWNLOAD} from "../../images/download.svg"
import {ReactComponent as CLOSE} from "../../images/Close.svg"
import {ReactComponent as SWITCH} from "../../images/arrows_clockwise_purple_icon.svg"
import {ReactComponent as SPEAKER} from "../../images/speaker_purple_icon.svg"
import YuJaButton from "../../components/standardization/YuJaButton";
import useWindowDimensions from "../../hooks/useWindowDimensions";

import Skeleton from "react-loading-skeleton";
import html2pdf from 'html2pdf.js';
import ShareUsageReportModal from "../../components/modals/ShareUsageReportModal";
import DOMPurify from 'dompurify';
import {useCSMAccessCheck} from "../../hooks/useCSMAccessCheck";
import {delay} from "../../utils/helpers";
import {Button} from "@base-ui/react/button";
import { useTranslation } from "react-i18next";


export default function ReportUsagePage(props) {
    const { t } = useTranslation();
    const {listMonthUsageReports, getMonthlyUsage} = ReportApiCalls();
    const windowDimensions = useWindowDimensions();
    let {checkIsFromCSM} = useCSMAccessCheck();
    const {width} = windowDimensions;

    const [reportStartDate, setReportStartDate] = useState(() => {
        let currentDate = new Date();
        currentDate.setDate(1);
        currentDate.setMonth(currentDate.getMonth() - 6);
        return getYearMonthStr(currentDate);
    });

    const [reportEndDate, setReportEndDate] = useState(() =>{
        let currentDate = new Date();
        currentDate.setDate(1);
        return getYearMonthStr(currentDate);
    });

    const [curDate, ] = useState(() =>{
        let currentDate = new Date();
        currentDate.setDate(1);
        return getYearMonthStr(currentDate);
    });

    const [reportData, setReportData] = useState([]);
    const [rawData, setRawData] = useState([]);
    const [keyword, setKeyword] = useState("");
    const [monthlyUsageHtml, setMonthlyUsageHtml] = useState("");
    const [isOpen, setIsOpen] = useState(false);
    const [isProgressing, setIsProgressing] = useState(false);
    const [isListing, setIsListing] = useState(true);
    const [isModalShown, setIsModalShown] = useState(false);
    const [selectedYearMonth, setSelectedYearMonth] = useState("");
    const [isCSMView, setIsCSMView] = useState(false);

    const pdfBlobCur = useRef();


    useEffect(() => {
        setIsListing(true);
        listMonthUsageReports(reportStartDate, reportEndDate, isCSMView).then(res => {
            setReportData(res);
            setRawData(res);
        }).finally(() => {
            setIsListing(false);
        });
    }, [reportStartDate, reportEndDate, isCSMView]);

    useEffect(() => {
        props.setPageIdentifier("Usage Report");
    }, []);

    useEffect(() => {
        if (!keyword) {
            setReportData(rawData);
        } else {
            setReportData(rawData.filter(data => {
                let yearMonth = data.title.split("-")[0].toLowerCase();
                return yearMonth.indexOf(keyword.toLowerCase()) !== -1;
            }));
        }
    }, [rawData, keyword]);


    useEffect(() => {
        const targetDiv = document.getElementById("highlightUsageTarget");
        if(!isOpen || !!isProgressing || !monthlyUsageHtml || !targetDiv) {
            return;
        }

        targetDiv.innerHTML = DOMPurify.sanitize(monthlyUsageHtml, {
            FORCE_BODY: true,
        });

        targetDiv.querySelectorAll("tbody td").forEach(el => {
            el.style.setProperty("background-color", "transparent", "important");
        });

        targetDiv.querySelectorAll("div.border").forEach(el => {
            el.style.overflow = "hidden";
        });

        // targetDiv.querySelectorAll('[style*="line-height:1"]').forEach(el => {
        //     el.style.lineHeight = "1.4";
        // });
    }, [isOpen, isProgressing, monthlyUsageHtml]);

    const openReport = (yearMonth) => {
        setIsOpen(true);
        setIsProgressing(true);
        // yearMonthCur.current = yearMonth;
        setSelectedYearMonth(yearMonth);
        getMonthlyUsage(yearMonth, isCSMView).then(async (htmlString) => {
            setMonthlyUsageHtml(htmlString);
            await convertPDF(htmlString);
        }).finally(() => {
            setIsProgressing(false);
        })
    }

    const convertPDF = async (htmlString) => {
        const tempContainer = document.createElement('div');
        tempContainer.style.display = 'none'; // Hide the container completely
        tempContainer.innerHTML = DOMPurify.sanitize(htmlString, {
            FORCE_BODY: true,
        });

        // Append the container to the body so it's part of the live document for queries
        document.body.appendChild(tempContainer);

        const el = tempContainer.querySelector('[style*="margin:0px auto"][style*="max-width:900px"]');
        // if (el) {
        //     // Instead of changing maxWidth, use a scale
        //     // This shrinks the visual size without changing the layout logic
        //     el.style.transform = 'scale(0.9)';
        //     el.style.transformOrigin = 'top center';
        // }
        if (el) {
            el.style.maxWidth = `${Math.min(0.9 * width, 900) - 200}px`;
        }

        tempContainer.querySelectorAll("tbody td").forEach(td => {
            td.style.setProperty("background-color", "transparent", "important");
        });
        //

        let finalHtmlString = tempContainer.outerHTML;
        const openTag = '<div style="display: none;">';
        const closeTag = '</div>';
        // A. Check and replace the opening tag
        if (finalHtmlString.startsWith(openTag)) {
            // Replace the opening tag with the desired <html><body> structure
            finalHtmlString = '<html><body>' + finalHtmlString.slice(openTag.length);
        } else {
            console.warn("Could not find expected opening tag for replacement.");
        }

        // B. Check and replace the closing tag
        if (finalHtmlString.endsWith(closeTag)) {
            // Remove the closing tag and append the desired </body></html> structure
            finalHtmlString = finalHtmlString.slice(0, finalHtmlString.length - closeTag.length) + '</body></html>';
        } else {
            console.warn("Could not find expected closing tag for replacement.");
        }
        document.body.removeChild(tempContainer);

        let html2pdfSettings = {
            margin: 10,
            filename: `EngageUsageReport.pdf`,
            image: { type: 'jpeg', quality: 1 },
            html2canvas: { scale: 1, useCORS: true, removeContainer: false },
            jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait', },
        };
        if (!isCSMView) {
            html2pdfSettings.pagebreak = {
                mode: ['avoid-all'],
                avoid: ['.metric-card-block', 'img']
            };
        } else {
            html2pdfSettings.pagebreak = {
                avoid: ['.metric-card-block']
            };
        }

        await delay(1000);
        pdfBlobCur.current = await html2pdf().set(html2pdfSettings).from(finalHtmlString).output('blob');
    }

    const onDownload = () => {
        if (!!pdfBlobCur.current) {
            let year = selectedYearMonth.split("-")[0];
            let month = selectedYearMonth.split("-")[1];
            // Create a temporary URL for the Blob
            const url = URL.createObjectURL(pdfBlobCur.current);

            // Create a temporary link element
            const a = document.createElement('a');
            a.href = url;
            a.download = `EngageUsageReport_${month}_${year}.pdf`;

            // Programmatically click the link to trigger download
            document.body.appendChild(a);
            a.click();

            // Clean up the temporary URL and element
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        }
    }


    useEffect(() => {
        const handleKeyDownDropdown = (event) => {
            if (event.key !== "Tab") {
                return;
            }
            const container = document.querySelector("#usageReportDetailContainer");
            if (!container) {
                return;
            }

            const focusableElements = container.querySelectorAll('[tabindex]:not([tabindex="-1"]), input');

            if (!container.contains(event.target)) {
                event.preventDefault();
                focusableElements[0].focus();
                return;
            }

            if (event.shiftKey) {
                for (let i = 0; i < focusableElements.length; i++) {
                    if (focusableElements[i] !== event.target) {
                        continue;
                    }
                    if (i === 0) {
                        event.preventDefault();
                        focusableElements[focusableElements.length - 1].focus();
                        return;
                    } else {
                        event.preventDefault();
                        focusableElements[i - 1].focus();
                        return;
                    }
                }
            } else {
                for (let i = 0; i < focusableElements.length; i++) {
                    if (focusableElements[i] !== event.target) {
                        continue;
                    }
                    if (i === focusableElements.length - 1) {
                        event.preventDefault();
                        focusableElements[0].focus();
                        return;
                    } else {
                        event.preventDefault();
                        focusableElements[i + 1].focus();
                        return;
                    }
                }
            }

        };

        if (!!isOpen) {
            document.addEventListener("keydown", handleKeyDownDropdown);
        }


        return () => {
            document.removeEventListener("keydown", handleKeyDownDropdown);
        };
    }, [isOpen]);

    return (
        <div className={classes.parentContainer} style={{height: "100%"}}>
            <ShareUsageReportModal setModalShow={setIsModalShown} show={isModalShown} yearMonth={selectedYearMonth} isCSMView={isCSMView}/>
            <div className={classes.usageCard}>
                {isCSMView &&
                    <div className={classes.CSMViewBanner}>
                        <SPEAKER style={{marginRight: 8, flexShrink: 0}}/>
                        <span>
                            <span className={classes.title}>{t("report.confidential")}</span>
                            {t("report.confidentialDesc")}
                        </span>
                    </div>
                }
                {checkIsFromCSM() &&
                    <div className={classes.headerContainer}>
                        <div className={classes.headerSpacer}/>
                        <h2 className={classes.title}>{t("report.usageReportsTitle")}</h2>
                        <div className={classes.headerButtonWrapper}>
                            <YuJaButton style={{height: 35}} onClick={() => setIsCSMView(!isCSMView)}>
                                <SWITCH style={{marginRight: 5}}/>
                                {isCSMView ? t("institution.switchToAdminView") : t("institution.switchToCsmView")}
                            </YuJaButton>
                        </div>
                    </div>
                }

                <div style={{height: 20}}/>
                <div className={classes.filterCard}>
                    <YuJaTextBox
                        containerStyle={{fontSize: 14, lineHeight: 1.6, flex: 1, height: 35, minWidth: 200}}
                        onChange={e => setKeyword(e.target.value)}
                        value={keyword}
                        before={<SearchIcon style={{marginRight: 5, width: 16}}/>}
                        after={
                            !!keyword
                                ? (
                                    <Button
                                        aria-label={t("accessibility.clearSearchKeyword")}
                                        className={classes.closeIcon}
                                        onClick={() => setKeyword("")}
                                    >
                                        <CLOSE style={{width: 16, height: 16}}/>
                                    </Button>
                                )
                                : (<></>)
                        }
                        placeholder={t("report.searchByMonthYear")}
                    />

                    <div style={{width: 20}}/>

                    <div className={classes.filterController}>
                        <span className={classes.regularLabel} style={{marginRight: 5}}>{t("report.dateFilterLabel")}</span>
                        <MonthPicker dateStr={reportStartDate} setDateStr={setReportStartDate}
                                     maxDateStr={reportEndDate}/>
                        <ARROW_RIGHT style={{marginLeft: 5, marginRight: 5}}/>
                        <MonthPicker dateStr={reportEndDate} setDateStr={setReportEndDate}
                                     minDateStr={reportStartDate} maxDateStr={curDate}/>
                    </div>
                </div>

                <div style={{height: 20}}/>
                <div className={classes.usageMonthlyCardContainer}>
                    {!!isListing &&
                        Array.from({length: 3}).map((_, index) =>
                           <div
                               key={index}
                               className={classes.usageMonthlyCard}
                               style={{background: "transparent", border: "none", display: "unset", padding: 0}}
                           >
                               <Skeleton borderRadius={4} height={250} width={"100%"}/>
                           </div>
                        )
                    }

                    {!isListing && reportData.length > 0 && reportData.map((data, index) =>
                        <div key={index} className={classes.usageMonthlyCard}>
                            <div className={classes.imgWrapper}>
                                {!!data.hasOwnProperty("overviewGraph") && !!data.overviewGraph &&
                                    <img className={classes.usageMonthlyCardOverViewImg} src={data.overviewGraph}
                                         alt={t("accessibility.usageReportChart")}/>
                                }


                                {!data.overviewGraph &&
                                    <div className={classes.gradientContainer}>
                                        <div className={classes.gradientBG}>
                                        </div>

                                        <span style={{marginBottom: 5}}>{data.title.split("-")[0]}</span>
                                        <span className={classes.gradientText}>{t("report.monthlyReport")}</span>
                                    </div>

                                }


                            </div>

                            <div style={{display: "flex", flexDirection: "column", gap: 15, flex: 1, minWidth: 500}}>
                                <span className={classes.title}>{data.title}</span>
                                <span className={classes.description}>{data.summary}</span>
                                <YuJaButton
                                    style={{
                                        width: 110,
                                        height: 36,
                                        fontSize: 14,
                                        lineHeight: 1.6,
                                        whiteSpace: "nowrap"
                                    }}
                                    onClick={() => openReport(data.yearMonth)}
                                >{t("report.viewReport")}</YuJaButton>
                            </div>


                        </div>
                    )}


                    {!isListing && !reportData.length &&
                        <>
                            <div style={{flex: 1}}/>
                            <NO_RESULT style={{alignSelf: "center"}}/>
                            <div>
                                <div
                                    style={{
                                        fontWeight: "600", fontSize: 20, lineHeight: 1.4, textAlign: "center",
                                        marginTop: 20, marginBottom: 20
                                    }}
                                >{t("institution.bannerNoMatchingResults")}</div>
                                <div
                                    style={{
                                        fontSize: 15, textAlign: "center",
                                    }}
                                >{t("report.noResultsDesc")}</div>
                            </div>
                            <div style={{flex: 1}}/>
                        </>
                    }
                </div>


                {isOpen &&
                    <div
                        id={"usageReportDetailContainer"}
                        style={{
                            position: "absolute", top: 0, left: 0, width: "100%", height: "100%",
                            background: "#FFFFFF", display: "flex", flexDirection: "column", padding: 25
                        }}
                    >
                        {isCSMView &&
                            <div className={classes.CSMViewBanner}>
                                <SPEAKER style={{marginRight: 8, flexShrink: 0}}/>
                                <span>
                                    <span className={classes.title}>{t("report.confidential")}</span>
                                    {t("report.confidentialDesc")}
                                </span>
                            </div>
                        }
                        <div className={classes.row} style={{marginBottom: 20}}>
                            <span
                                tabIndex={0}
                                style={{
                                    cursor: "pointer", display: "flex", alignItems: "center",
                                    width: "fit-content",
                                    outlineOffset: -2,
                                }}
                                onClick={() => setIsOpen(false)}
                            >
                                <BACK style={{marginRight: 2}}/>
                                <span>{t("report.backToReports")}</span>
                            </span>
                            <div style={{flex: 1}}/>
                            <YuJaButton
                                onClick={() => setIsModalShown(true)}
                                style={{
                                    height: 36,
                                    fontSize: 14,
                                    lineHeight: 1.6,
                                    whiteSpace: "nowrap",
                                    marginRight: 15,
                                }}
                            ><SHARE style={{marginRight: 5}}/>{t("sharePoll.shareLabel")}</YuJaButton>

                            <YuJaButton
                                style={{
                                    height: 36,
                                    fontSize: 14,
                                    lineHeight: 1.6,
                                    whiteSpace: "nowrap"
                                }}
                                onClick={onDownload}
                            ><DOWNLOAD style={{marginRight: 5}}/>{t("common.download")}</YuJaButton>
                        </div>

                        {!isProgressing &&
                            <div
                                id={"highlightUsageTarget"}
                                style={{flex: 1, minHeight: 0, overflow: "scroll", scrollbarWidth: "none"}}
                            />
                        }


                        {isProgressing &&
                            <>
                                <div style={{alignSelf: "center", marginBottom: 50}}>
                                    <Skeleton width={80} height={36} borderRadius={8} inline={true}
                                              style={{alignSelf: "center"}}/>
                                </div>

                                <div style={{alignSelf: "center", marginBottom: 30}}>
                                    <Skeleton width={100} height={20} borderRadius={3} inline={true}
                                              style={{alignSelf: "center"}}/>
                                </div>

                                <div style={{alignSelf: "center", marginBottom: 20}}>
                                    <Skeleton width={500} height={50} borderRadius={8} inline={true}
                                              style={{alignSelf: "center"}}/>
                                </div>


                                <div style={{width: "min(90%, 900px)", alignSelf: "center", marginBottom: 20}}>
                                    <Skeleton width={"100%"} height={300} borderRadius={8} inline={true}
                                              style={{alignSelf: "center"}}/>
                                </div>
                                <div style={{width: "min(90%, 900px)", alignSelf: "center", marginBottom: 20}}>
                                    <Skeleton width={"100%"} height={300} borderRadius={8} inline={true}
                                              style={{alignSelf: "center"}}/>
                                </div>

                                <div style={{width: "min(90%, 900px)", alignSelf: "center", marginBottom: 20}}>
                                    <Skeleton width={"100%"} height={300} borderRadius={8} inline={true}
                                              style={{alignSelf: "center"}}/>
                                </div>
                            </>
                        }
                    </div>
                }
            </div>
        </div>
    );
}